<template>
    <div class="marunage-table">
        <div class="mb-2">
            <div v-if="mode === 'read'">
<!--
                <div>
                    <small class="text-danger">※登録後30日以内に追跡有効確認ができないデータについては、自動で無効になります。</small>
                </div>
-->
            </div>
            <div v-if="mode === 'create' || mode === 'update'">
                <template v-if="mode === 'create'">
                    <b-button variant="outline-secondary" @click="addRow">行追加</b-button>
                    <b-button variant="outline-danger" @click="removeRow">行削除</b-button>
                    <b-dropdown variant="outline-primary" text="CSV">
                        <b-dropdown-item-button>
                            <label>
                                CSVアップロード
                                <input type="file" accept="text/csv" class="d-none" @change="uploadMarunageCsv" />
                            </label>
                        </b-dropdown-item-button>
                        <b-dropdown-item @click="downloadMarunageCsv">
                            CSVダウンロード（サンプル）
                        </b-dropdown-item>
                    </b-dropdown>
                </template>

                <b-row class="mt-3">
                    <b-col>
                        <strong>使い方のヒント</strong>
                        <ul class="mb-0">
                            <li>ExcelやSpreadsheetのデータをまとめてコピペ対応</li>
                            <li>セル編集中にCtrl+Enterでセル内改行</li>
                            <li>セルをダブルクリックでデータ読込ダイアログ表示</li>
                        </ul>
                    </b-col>
                    <b-col class="align-self-end text-right">
<!--
                        <div><a class="text-danger" href="https://docs.google.com/spreadsheets/d/1_24hwW-e2m7bpaY0nsceHgiDgtFw8REMO4eC3JNIpdM/edit?usp=sharing" target="_blank">受取人国の許可禁止一覧表へのリンクはこちら</a></div>
                        <div><a class="text-danger" href="https://www.bk.mufg.jp/ippan/kinri/list_j/kinri/kawase.html" target="_blank">三菱ＵＦＪ銀行為替相場一覧表へのリンクはこちら</a></div>
                        <div><strong>※申告金額は千円単位切り上げとなります。</strong></div>
-->
                    </b-col>
                </b-row>

                <b-modal
                    id="modal-from"
                    @show="onShowModalFrom"
                    @ok="onOkModalFrom"
                    size="lg"
                    >
                    <AddressSearch
                        :prefixes="[ 'from', ]"
                        @select="onSelectAddress"
                        />

                    <h6 class="mt-5"><strong>手動入力</strong></h6>
                    <b-table-simple stacked borderless small class="b-table-nullable">
                        <AddressContent
                            v-model="modal"
                            :prefixes="[ 'from_', ]"
                            :error="dummy"
                            :fields="{
                                representative: false,
                                company: false,
                            }"
                            />
                        <b-tbody class="address-content">
                            <b-tr>
                                <b-th class="shipping-address-th">住所(en)</b-th>
                                <b-td>
                                    <b-form-input
                                        v-model="modal['from_address']"
                                        size="sm"
                                        ></b-form-input>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                        <AddressContent
                            v-model="modal"
                            :prefixes="[ 'from_', ]"
                            :error="dummy"
                            :fields="{
                                tel: false,
                                email: false,
                            }"
                            />
                    </b-table-simple>
                </b-modal>

                <b-modal
                    id="modal-to"
                    @show="onShowModalTo"
                    @ok="onOkModalTo"
                    size="lg"
                    >
                    <AddressSearch
                        :prefixes="[ 'to', ]"
                        @select="onSelectAddress"
                        :order_user_id="modal.user_id"
                        />

                    <h6 class="mt-5"><strong>手動入力</strong></h6>
                    <b-table-simple stacked borderless small class="b-table-nullable">
                        <AddressContent
                            v-model="modal"
                            :prefixes="[ 'to_', ]"
                            :error="dummy"
                            :fields="{
                                representative: false,
                                line1: false,
                                line2: false,
                                city: false,
                                state: false,
                                zip: false,
                                country: false,
                                tel: false,
                                email: false,
                                tax_id: false,
                            }"
                            />
                    </b-table-simple>
                </b-modal>

                <b-modal
                    id="modal-shipping"
                    @show="onShowModalShipping"
                    @ok="onOkModalShipping"
                    size="lg"
                    >
                    <div class="p-3 my-3 bg-light">
                        <strong>クーリエ</strong>
                    </div>
                    <vue-select
                        v-model="modal.shipping_courier"
                        :options="$store.state.app.data.shipping_courier || []"
                        label="value"
                        size="sm"
                        :reduce="v => v.value"
                        >
                    </vue-select>

                    <div class="p-3 my-3 bg-light">
                        <strong>Invoice番号</strong>
                    </div>
                    <b-form-input
                        v-model="modal.shipping_invoice_id"
                        />

                    <TrackingCodeContent
                        v-model="modal.shipping_tracking_codes"
                        />

                    <div class="p-3 my-3 bg-light">
                        <strong>申告商品情報</strong>
                    </div>

                    <div class="mb-0">
                        <strong>通貨</strong>
                        <SelectCurrencyId
                            v-model="modal.shipping_item_currency"
                            />
                    </div>

                    <ItemContent
                        v-model="modal.items"
                        :fields="[
                        'fetch',
                        'quantity',
                        'hs_code',
                        'country',
                        'product',
                        'price',
                        'subtotal',
                        ]"
                        :showRateLink="false"
                        :currency="modal.shipping_item_currency"
                        cast-price="float"
                        @onChangeCurrency="onChangeCurrency"
                        />
                </b-modal>
            </div>

        </div>
        <div class="overflow-hidden" :style="'height: ' + styleHeight">
            <hot-table
                ref="hotTable"
                class="h-100"
                :mode="mode"
                :settings="hotSettings"
                @after-init="afterInit"
                @before-paste="beforePaste"
                />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HotTable } from '@handsontable/vue'
import { registerAllModules } from 'handsontable/registry'
import Handsontable from 'handsontable'
import AddressSearch from '@/components/AddressSearch.vue'
import AddressContent from '@/components/AddressContent.vue'
import TrackingCodeContent from '@/components/TrackingCodeContent.vue'
import ItemContent from '@/components/ItemContent.vue'
import BoxContent from '@/components/BoxContent.vue'
import SelectCurrencyId from '@/components/SelectCurrencyId.vue'
import moment from 'moment'
import { MARUNAGE_TABLE } from '@/plugins/handsontable'

const FIELDS = MARUNAGE_TABLE().FIELDS
const FIELDS_ALL = MARUNAGE_TABLE().FIELDS_ALL
const data2JsonObject = MARUNAGE_TABLE().METHODS.data2JsonObject

registerAllModules()

const getShippingItemPriceTotal = async function (instance, row) {
    const obj = data2JsonObject([ instance.getDataAtRow(row) ])[0]

    if (!obj.shipping_item_price) {
        return null
    }

    let total = 0
    let prices = []
    let quantities = []
    prices = (obj.shipping_item_price || '').split("\n").map((v) => {
        return parseFloat(v)
    })
    quantities = (obj.shipping_item_quantity || '').split("\n").map((v) => {
        return parseInt(v)
    })
    if (prices.length !== quantities.length) {
        FIELDS_ALL.forEach((v, i) => {
            if (v.name === 'shipping_item_price_total') {
                instance.setDataAtCell(row, i, '')
            }
        })
        return null
    }
    for (let i = 0; i < prices.length; i++) {
        total += prices[i] * quantities[i]
    }
    if (!total) {
        return null
    }

    // 為替
    let shipping_marunage = await this.$store
        .dispatch('marunage/calc_shipping_marunage', {
            currency: obj.shipping_item_currency,
            price: total,
        })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return null
        })

    if (shipping_marunage) {
        return shipping_marunage.shipping_item_price_total
    }
    return null
}
const calcShippingItemPriceTotal = async function (instance, row) {
    const total = await getShippingItemPriceTotal.call(this, instance, row)
    FIELDS_ALL.forEach((v, i) => {
        if (v.name === 'shipping_item_price_total') {
            const value_old = instance.getDataAtCell(row, i)
            if (value_old !== total) {
                instance.setDataAtCell(row, i, total)
            }
        }
    })

}
const jsonObject2Data = (jsonObject) => {
    return jsonObject.map((v) => {
        return FIELDS_ALL.map((field) => {
            return field.load(v)
        })
    })
}
const urlValidator = (value, callback) => {
    let urls = value.split(',')
    if (urls.length !== 1) {
        callback(false)
    }
    return urlsValidator(value, callback)
}
const urlsValidator = (value, callback) => {
    if (value === null || value === '') {
        callback(true)
        return
    }
    let urls = value.split(',')
    for (let i = 0; i < urls.length; i++) {
        let url = urls[i]
        if (!isValidHttpUrl(url)) {
            callback(false)
            return
        }
    }
    callback(true)
}
const isValidHttpUrl = (string) => {
    let url
    try {
        url = new URL(string)
    } catch (_) {
        return false
    }
    return url.protocol === 'http:' || url.protocol === 'https:'
}

export default {
    components: {
        HotTable,
        AddressSearch,
        AddressContent,
        TrackingCodeContent,
        ItemContent,
        BoxContent,
        SelectCurrencyId,
    },
    props: {
        mode: {
            type: String,
            required: true,
            default: 'read',
            // create, read, update
        },
        errors: {
            type: Array,
            required: false,
            default() {
                return []
            },
        },
        jsonKey: {
            type: String,
            required: false,
            default() {
                return null
            },
        },
        styleHeight: {
            type: String,
            required: false,
            default: 'calc(100vh - 25em)',
        },
    },
    watch: {
    },
    data() {
        return {
            hotRef: null,
            hotSettings: {
                readOnly: true,
                rowHeaders: true,
                colHeaders: true,
                licenseKey: 'non-commercial-and-evaluation',
                stretchH: 'all',
                contextMenu: false,
                width: '100%',
                allowInsertColumn: false,
                allowInsertRow: false,
                allowRemoveColumn: false,
                allowRemoveRow: false,
                outsideClickDeselects: false,
                selectionMode: 'range',

                autoRowSize : false,
                observeDOMVisibility: true,
                viewportColumnRenderingOffset: 70,

                colHeaders: FIELDS_ALL
                    .map((v) => { return v.colHeader })
                    ,
                columns: FIELDS_ALL
                    .map((v) => { return v.column })
                    ,
//                data: [],
                hiddenColumns: {
                    copyPasteEnabled: false,
                },
                colWidths: this.colWidths,

                // event
                afterInit() {
                    this.rootElement.__vue__.$emit('after-init')
                },
                afterGetColHeader: function(col, TH) {
                    TH.className = 'text-left align-bottom'
                },
                afterGetRowHeader: this.afterGetRowHeader,
                afterChange: this.afterChange,
                afterOnCellMouseDown: this.afterOnCellMouseDown,
                beforePaste (data, range) {
                    this.rootElement.__vue__.$emit('before-paste', data, range)
                },
                cells: this.cells,
            },
            modal: {
            },
            dummy: {
            },
        }
    },
    computed: {
        ...mapGetters([
            'auth_id',
            'auth_uuid',
            'auth_level',
            'auth_group',
            'trans',
            'shipping_address_default',
            'shipping_item_default',
            'marunage_default',
            'create_marunage',
            'trim_address',
        ]),
    },
    async mounted() {
        this.timer = window.setInterval(() => {
            if (this.$refs.hotTable) {
                this.$refs.hotTable.hotInstance.updateSettings({})
            }
        }, 1 * 3 * 1000)
    },
    methods: {
        afterInit () {
            this.$watch('mode', (value_new, value_old) => {
                this.setup()
            }, {
                immediate: true, // オプション
            })
        },
        afterOnCellMouseDown (event, cell, el) {
            var now = new Date().getTime()
            if(!(el.lastClick && now - el.lastClick < 1000)) {
                el.lastClick = now
                return
            }

            if (! [ 'create', 'update', ].includes(this.mode)) {
                return
            }

            let is_user_col = FIELDS.USER
                .map((v) => { return this.getColumnIndexByName(v.name) })
                .includes(cell.col)
            let is_inspector_col = FIELDS.INSPECTOR
                .map((v) => { return this.getColumnIndexByName(v.name) })
                .includes(cell.col)
            let is_d3pl_col = FIELDS.D3PL
                .map((v) => { return this.getColumnIndexByName(v.name) })
                .includes(cell.col)
            if (is_user_col) {
                this.$bvModal.show('modal-user')
            }
            if (is_inspector_col) {
                this.$bvModal.show('modal-inspector')
            }
            if (is_d3pl_col) {
                this.$bvModal.show('modal-d3pl')
            }
        },
        afterChange (changes, source) {
            if (!changes) {
                return
            }

//            let needs_calc = []
            let change_to_render = false
            for (let i = 0; i < changes.length; i++) {
                let row = changes[i][0]
                let col = changes[i][1]
                let column = FIELDS_ALL[col]
console.log(changes[i])
console.log(row, col)
console.log(column)
                if (!column) {
                    continue
                }
                if (column.change_to_render) {
                    change_to_render = true
                    break
                }

//                switch (column.name) {
//                    case 'shipping_item_quantity':
//                    case 'shipping_item_currency':
//                    case 'shipping_item_price':
//                        needs_calc.push(row)
//                        break
//                }
            }
console.log('change_to_render')
console.log(change_to_render)
            if (change_to_render) {
                // TODO: cellMeta.isDirty
                this.$refs.hotTable.hotInstance.render()
                this.$forceUpdate()
            }
//
//            needs_calc = Array.from(new Set(needs_calc))
//            if (needs_calc.length) {
//                for (let i = 0; i < needs_calc.length; i++) {
//                   calcShippingItemPriceTotal.call(this, this.$refs.hotTable.hotInstance, needs_calc[i])
//                }
//            }
        },
        afterGetRowHeader (row, TH) {
            TH.className = 'text-left'
            const rowHeader = TH.querySelector('.rowHeader')
            rowHeader.innerHTML = ''
            switch (this.mode) {
                case 'create':
                    rowHeader.innerHTML = row + 1
                    break;
                case 'update':
                    rowHeader.innerHTML = row + 1
                    break;
                case 'read':
                default:
//                    if (this.auth_level !== '300') {
//                        break
//                    }
                    const a = document.createElement('a')
                    a.innerText = '開く'
                    a.href = 'javascript:void(0)'
                    a.setAttribute('row', row)
                    a.addEventListener('click', this.onClickDetail)
                    rowHeader.appendChild(a)
                    break;
            }
        },
        onClickDetail (event) {
            let row = Math.trunc(event.target.getAttribute('row'))
            if (Number.isNaN(row)) {
                return
            }

            let data = this.getData()
            if (row >= data.length) {
                return
            }

            this.$emit('on-detail', data[row])
        },
        beforePaste (data, range) {
            if (this.mode !== 'create') {
                return
            }
            const startRow = range[0].startRow
            const count = this.$refs.hotTable.hotInstance.countRows()
            
            for (let i = 0; i < data.length + startRow - count; i++) {
                this.$refs.hotTable.hotInstance.alter('insert_row')
            }
        },
        cells (row, column, prop) {
            let cell = null
            try {
                cell = this.$refs.hotTable.hotInstance.getCell(row, column)
            } catch (e) {}
            let cellProperties = {
                readOnly: this.hotSettings.readOnly,
            }
            if (FIELDS_ALL[column].readOnly) {
                cellProperties.readOnly = true
            }
            if (cell) {
//                if (cellProperties.readOnly) {
//                    cell.style.backgroundColor = "#dddddd"
//                } else {
//                    cell.style.backgroundColor = "inherit"
//                }
//                console.log(cell.style)
            }
            return cellProperties
        },
        setup () {
            let hidden_columns = []
            const column_index_user_id = this.getColumnIndexByName('user_id')
            if (column_index_user_id === -1) {
                return
            }
            switch (this.mode) {
                case 'create':
                    hidden_columns = []
                        .concat(FIELDS.SYSTEM)
                        .concat(FIELDS.SYSTEM_UPDATED_AT)
                        .map((v) => { return this.getColumnIndexByName(v.name) })
                    this.hotSettings.readOnly = false

                    if (this.auth_level >= '200') {
                        hidden_columns = hidden_columns.filter((v) => {
                            return ![
                                column_index_user_id,
                            ].includes(v)
                            return ![
                                'user_id',
                            ].includes(FIELDS_ALL[v].name)
                        })
                        FIELDS_ALL[column_index_user_id].readOnly = false
                    }
                    break
                case 'update':
                    hidden_columns = []
                        .concat(FIELDS.SYSTEM_UPDATED_AT)
                        .map((v) => { return this.getColumnIndexByName(v.name) })
                    this.hotSettings.readOnly = false
                    break
                case 'read':
                default:
                    hidden_columns = []
                        .concat(FIELDS.SYSTEM_UPDATED_AT)
                        .map((v) => { return this.getColumnIndexByName(v.name) })
                    this.hotSettings.readOnly = true
                    break
            }

            // user_id
            FIELDS_ALL[column_index_user_id].column.type = 'handsontable'
            FIELDS_ALL[column_index_user_id].column.renderer = (instance, td, row, col, prop, value, cellProperties) =>  {
                if (!value) {
                    td.innerText = ''
                    return td
                }
                td.innerText = value + ': '
                let text = '不明なユーザー'
                for (let i = 0; i < this.auth_group.length; i++) {
                    if ((value + '') === (this.auth_group[i].id + '')) {
                        text = this.auth_group[i].nickname
                        break
                    }
                }
                td.innerText += text
                return td
            }
            FIELDS_ALL[column_index_user_id].column.handsontable = {
                colHeaders: false,
                autoColumnSize: true,
                data: this.auth_group,
                getValue() {
                    const selection = this.getSelectedLast()
                    return this.getSourceDataAtRow(Math.max(selection[0], 0)).id
                },
            }
            this.$set(
                this.hotSettings,
                'columns',
                FIELDS_ALL.map((v) => { return v.column })
            )

            // updateSettings
            this.$refs.hotTable.hotInstance.updateSettings(this.hotSettings)

            // hidden columns
            let pluginHiddenColumns = this.$refs.hotTable.hotInstance.getPlugin('hiddenColumns')
            pluginHiddenColumns.hideColumns(hidden_columns)

            this.$refs.hotTable.hotInstance.render()
            this.$forceUpdate()
        },
        getColumnIndexByName(name) {
            let field_names =
                FIELDS_ALL
                .map((v) => { return v.name })
            return field_names.indexOf(name)
        },
        getVisibleColumns () {
            let pluginHiddenColumns = this.$refs.hotTable.hotInstance.getPlugin('hiddenColumns')
            let visibleColumns = []
            for (let i = 0; i < this.$refs.hotTable.hotInstance.getColHeader().length; i++) {
                if (pluginHiddenColumns.getHiddenColumns().indexOf(i) === -1) {
                    visibleColumns.push(i)
                }
            }
            return visibleColumns
        },
        getVisibleColumnFirst () {
            let cols = this.getVisibleColumns()
            return cols.length ? cols[0] : 0
        },
        loadData (hits) {
            this.deselectCell()
            this.$refs.hotTable.hotInstance.loadData(this.jsonObject2Data(hits))
            this.setup()
            this.$forceUpdate()
        },
        loadPartialData (hits) {
            let range = this.$refs.hotTable.hotInstance.getSelectedRange()
            if (!range) {
                let visibleColumn = this.getVisibleColumnFirst()
                this.$refs.hotTable.hotInstance.selectCell(0, visibleColumn, 0, visibleColumn)
                range = this.$refs.hotTable.hotInstance.getSelectedRange()
            }
            range = range[0]

            hits = this.jsonObject2Data(hits)

            let changes = [];
            for (let row = range.from.row; row <= range.to.row; row++) {
                for (let col = 0; col <= hits[0].length; col++) {
                    if (typeof hits[0][col] === 'undefined') {
                        continue
                    }
                    changes.push([ row, col, hits[0][col], ])
                }
            }
            this.$refs.hotTable.hotInstance.setDataAtCell(changes)
        },
        getData () {
            return data2JsonObject(this.$refs.hotTable.hotInstance.getData())
        },
        getDataRanged () {
            let range = this.$refs.hotTable.hotInstance.getSelectedRange()
            if (!range) {
                let visibleColumn = this.getVisibleColumnFirst()
                this.$refs.hotTable.hotInstance.selectCell(0, visibleColumn, 0, visibleColumn)
                range = this.$refs.hotTable.hotInstance.getSelectedRange()
            }
            range = range[0]

            let row = range.from.row
            if (Number.isNaN(row)) {
                return
            }

            let data = this.getData()
            if (row >= data.length) {
                return
            }

            return data[row]
        },
        jsonObject2Data (jsonObject) {
            return jsonObject2Data(jsonObject)
        },
//        data2JsonObject (data) {
//            return data2JsonObject(data)
//        },
        addRow () {
            let ranges = this.$refs.hotTable.hotInstance.getSelectedRange()
            let rowNew = 0
            if (!ranges) {
                this.$refs.hotTable.hotInstance.alter('insert_row_below')
                rowNew++
            } else {
                for (let i = ranges.length - 1; i >= 0; i--) {
                    this.$refs.hotTable.hotInstance.alter('insert_row_below', ranges[i].from.row + 0)
                    rowNew = ranges[i].from.row + 1
                }
            }
            let visibleColumn = this.getVisibleColumnFirst()
            this.$refs.hotTable.hotInstance.selectCell(rowNew, visibleColumn, rowNew, visibleColumn)

            this.loadPartialData([ this.marunage_default, ])
        },
        removeRow () {
            let ranges = this.$refs.hotTable.hotInstance.getSelectedRange()
            if (!ranges) {
                this.$refs.hotTable.hotInstance.alter('remove_row')
            } else {
                for (let i = ranges.length - 1; i >= 0; i--) {
                    const count = this.$refs.hotTable.hotInstance.countRows()
                    if (count <= ranges[i].from.row) {
                        continue
                    }
                    this.$refs.hotTable.hotInstance.alter('remove_row', ranges[i].from.row, ranges[i].to.row - ranges[i].from.row + 1)
                }
            }

            if (!this.$refs.hotTable.hotInstance.getData().length) {
                this.loadData([{}])
            }

            this.deselectCell()
        },
        deselectCell () {
            this.$refs.hotTable.hotInstance.deselectCell()
        },
        async onSelectAddress ($event, prefix, order_user_id, price, currency, product, quantity) {
            let options = {}
            options[prefix] = JSON.parse(JSON.stringify($event))
            let marunage = this.create_marunage(options)

            // set currency & price
            if (currency) {
                const h = this.$createElement
                const messageVNode = h('div', { class: [''] }, [
                    h('p', { class: ['text-left'] }, [
                        '発送情報の数量、申告商品名、通貨、単価もデータ反映しますか？',
                    ]),
                ])
                let result = await this.$bvModal.msgBoxConfirm([messageVNode], {
                    title: '入力内容の確認',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'はい',
                    cancelTitle: 'いいえ',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then((value) => {
//                    this.boxTwo = value
                    return value
                })
                .catch((error) => {
                    // An error occurred
                    return error
                })
                if (result) {
                    marunage.shipping_item_currency = currency
                    marunage.shipping_item_price = '' + price
                    marunage.shipping_item_name = '' + product
                    marunage.shipping_item_quantity = '' + quantity
                }
            }

//            if (order_user_id) {
//                marunage.user_id = order_user_id
//            }

            this.loadPartialData([ marunage, ])
            this.$bvModal.hide('modal-from')
            this.$bvModal.hide('modal-to')
            return
        },
        onShowModalFrom (event) {
            let row = this.getDataRanged()
            this.$utils.set(this.modal, this.trim_address(row, 'from'))
        },
        onOkModalFrom (event) {
            let row = JSON.parse(JSON.stringify(this.modal))
            this.loadPartialData([ this.trim_address(row, 'from'), ]);
        },
        onShowModalTo (event) {
            let row = this.getDataRanged()
            this.$utils.set(this.modal, this.trim_address(row, 'to'))
            this.$utils.set(this.modal, { 'user_id': row.user_id, })
        },
        onOkModalTo (event) {
            let row = JSON.parse(JSON.stringify(this.modal))
            this.loadPartialData([ this.trim_address(row, 'to'), ]);
        },
        onShowModalShipping (event) {
            let row = this.getDataRanged()

            let items = [];
            (row.shipping_item_quantity || '').split("\n").map((v, i) => {
                if (i >= items.length) {
                    items.push({})
                }
                items[i].quantity = v
            });
            (row.shipping_item_hs_code || '').split("\n").map((v, i) => {
                if (i >= items.length) {
                    items.push({})
                }
                items[i].hs_code = v
            });
            (row.shipping_item_country || '').split("\n").map((v, i) => {
                if (i >= items.length) {
                    items.push({})
                }
                items[i].country = v
            });
            (row.shipping_item_name || '').split("\n").map((v, i) => {
                if (i >= items.length) {
                    items.push({})
                }
                items[i].product = v
            });
            (row.shipping_item_price || '').split("\n").map((v, i) => {
                if (i >= items.length) {
                    items.push({})
                }
                items[i].price = v
            });
            this.$utils.set(this.modal, {
                shipping_courier: row.shipping_courier,
                shipping_invoice_id: row.shipping_invoice_id,
                shipping_tracking_codes: (row.shipping_tracking_codes || '').split("\n").map((v) => { return { shipping_tracking_code: v, } }),
                items: items,
                shipping_item_currency: row.shipping_item_currency,
            })
        },
        onOkModalShipping (event) {
            let row = JSON.parse(JSON.stringify(this.modal))
            this.$utils.set(row, {
                shipping_courier: row.shipping_courier,
                shipping_invoice_id: row.shipping_invoice_id,
                shipping_tracking_codes: row.shipping_tracking_codes.map((v) => { return v.shipping_tracking_code }).join("\n"),
                shipping_item_quantity: row.items.map((v) => { return v.quantity || 1 }).join("\n"),
                shipping_item_hs_code: row.items.map((v) => { return v.hs_code }).join("\n"),
                shipping_item_country: row.items.map((v) => { return v.country }).join("\n"),
                shipping_item_name: row.items.map((v) => { return v.product }).join("\n"),
                shipping_item_currency: row.shipping_item_currency,
                shipping_item_price: row.items.map((v) => { return v.price }).join("\n"),
            })
            this.loadPartialData([ row, ]);
        },
        onChangeCurrency (currency) {
            this.modal.shipping_item_currency = currency
        },
        async uploadMarunageCsv (event) {
            const file = event?.target?.files[0]
            const response = await this.$store
                .dispatch('marunage/upload_js', file)
            event.target.value = null

            if (!response || response.length === 0) {
                alert('読込失敗')
                return
            }

            this.loadData(response)

            const index = this.getColumnIndexByName('shipping_item_price')
            this.afterChange(
                [ ...Array(response.length) ].map((v, i) => [ i, index, ])
            )
        },
        async downloadMarunageCsv (event) {
            let data = {}

            // columns
            data.columns = this.getVisibleColumns()
                .filter((i) => {
                    return !FIELDS_ALL[i].readOnly
                })
                .map((i) => {
                    return FIELDS_ALL[i].name
                })

            // rows
            data.rows = [
                {
                    marunage_user_id: 'A01',
                    issued_at: '2025-10-20',
                    sequence_number: '1',
                    product: 'Nikon AF FX Micro-NIKKOR 200mm f/4D',
                    note_user: 'レンズ傷あり',
//                    note_inspector: '',
//                    note_checkup: 'ボディ傷あり',
                },
                {
                    marunage_user_id: 'A01',
                    issued_at: '2025-10-20',
                    sequence_number: '2',
                    product: 'Pentax 50-200 f4-5.6 ED',
                    note_user: '美品',
//                    note_inspector: '',
//                    note_checkup: '',
                },
            ]

            if (this.auth_level >= '200') {
            } else {
                data.rows.forEach((v) => {
                    delete v.user_id
                })
            }

            const response = await this.$store
                .dispatch('marunage/download_js', data)

            if (!response || response.length === 0) {
                alert('CSV作成失敗')
                return
            }

            const blob = new Blob([response], { type: 'text/csv' })
            
            const anchor = document.createElement('a')
            anchor.href = window.URL.createObjectURL(blob)//'data:text/csv;charset=utf-8,' + encodeURIComponent(blob)
            anchor.target = '_blank'
            anchor.download = 'marunage_sample.csv'
            anchor.click()
        },
    },
}
</script>

<style lang="scss">
$marunage_table_column_colors: (
    system: #fdfdfd,
    system_updated_at: #111111,
    user: #777777,
    inspector: #efefef,
    d3pl: #d9ead3,
);
$marunage_table_column_counts: (
    system: 2,
    system_updated_at: 1,
    user: 5,
    inspector: 5,
    d3pl: 14,
);
    
@mixin marunageTableThMixin($column_counts, $column_colors) {
    $index: 2;
    @each $key, $count in $column_counts {
        @for $i from 0 through $count {
            &:nth-child(#{$i + $index}){
                background-color: map-get($column_colors, $key);
            }

        }
        $index: $index + $count;
    }
}

.marunage-table {
    .handsontable {
        &[mode="read"],
        &[mode="update"] {
            table {
                thead {
                    th {
                        $marunage_table_column_counts: map-merge($marunage_table_column_counts, (
                            system_updated_at: 0,
                            profile: 0,
                        ));
                        @include marunageTableThMixin($marunage_table_column_counts, $marunage_table_column_colors);
                    }
                }
            }
        }
        &[mode="create"] {
            table {
                thead {
                    th {
                        $marunage_table_column_counts: map-merge($marunage_table_column_counts, (
                            system: 0,
                            system_updated_at: 0,
                            profile: 0,
                        ));
                        @include marunageTableThMixin($marunage_table_column_counts, $marunage_table_column_colors);
                    }
                }
            }
        }
    
        &[mode="read"] {
            table {
                thead {
                    th {
                        i.required {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}

@each $auth_level, $count in $auth_levels {
    $auth_level_threshold: 200;
    @if $auth_level >= $auth_level_threshold {
        [auth_level="#{$auth_level}"] {
            .marunage-table {
                .handsontable {
                    &[mode="create"] {
                        table {
                            thead {
                                th {
                                    // system: [ user_id ].length === 1
                                    $marunage_table_column_counts: map-merge($marunage_table_column_counts, (
                                        system: 2,
                                        system_updated_at: 0,
                                        profile: 0,
                                    ));
                                    @include marunageTableThMixin($marunage_table_column_counts, $marunage_table_column_colors);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
